import { BountyService } from './../services/bounty.service';
import { LoadingService } from '../services/loading.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { WindowService } from '../services/window.service';

@Injectable()
export class BountyResolver implements Resolve<{}> {
  constructor(
    private bountyService: BountyService,
    private loader: LoadingService,
    private windowService: WindowService,
  ) { }

  async resolve(state: ActivatedRouteSnapshot): Promise<Observable<any> | Promise<any> | any> {
    const preRenderedData = this.windowService.appData;
    if (preRenderedData) {
      // On first page load, return global data
      return preRenderedData;
    }

    const { id } = state.params;

    const data = await this.bountyService.get(id);

    return data;
  }
}
